export default __webpack_public_path__ + "static/media/onurbelgesi1.b3640f23.jpg";